import { Draft } from "../Draft.model";
import { DocumentType } from "../File.model";

export function parseDraft(raw: any): Draft {
    if (!raw) return raw;
    return {
        ...raw.draftInfo,
        rows: raw.rows,
        meta: raw.meta,
        isCodat: raw.draftInfo.identifierSource === "codat",
        isFile: raw.draftInfo.identifierSource === "file",
        isCleaned: raw.draftInfo.documentType === DocumentType.CLEANED,
        isLabeled: raw.draftInfo.documentType === DocumentType.LABELED,
    };
}
